import React from "react";
import { Modal, Avatar } from "@/components/vb";
import { renderMarkdownSafe } from "@/lib/markdown";
import { CiteRow } from "./ReceiptColumns";
import type { ProviderReceipt } from "./verdictModel";

/** Full-response dialog (VB-F2): the buyer's question + the complete verbatim
 *  answer (chat-style) and every source the model cited. Scrolls for long
 *  answers (the Modal body is overflow-y-auto). */
export function FullResponseModal({
  open,
  onOpenChange,
  provider,
  question,
  who,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  provider: ProviderReceipt | null;
  question: string;
  who: string;
}) {
  const answer = (provider?.answerText || "").trim();

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      srTitle="Full AI response"
      widthClassName="max-w-2xl"
    >
      {provider && (
        <div className="vb-resp">
          <div className="vb-resp-hd">
            <Avatar model={provider.providerKey} size="md" decorative />
            <span className="vb-rc-meta">
              <span className="vb-rc-name">{provider.label}</span>
            </span>
          </div>

          <div className="vb-resp-chat">
            <div className="vb-resp-q">
              <div className="vb-resp-q__bubble">{question}</div>
              {who && <div className="vb-resp-q__who">{who}</div>}
            </div>
            <div className="vb-resp-a">
              <div className="vb-resp-a__bubble">
                {answer ? (
                  <div
                    className="vb-md"
                    dangerouslySetInnerHTML={{ __html: renderMarkdownSafe(answer) }}
                  />
                ) : (
                  <p>No answer was returned by this model.</p>
                )}
              </div>
              {provider.citations.length > 0 && (
                <div className="vb-resp-sources">
                  <div className="vb-rc-cited-hd">Cited {provider.citations.length} sources</div>
                  <div className="vb-rc-cites">
                    {provider.citations.map((c, i) => (
                      <CiteRow cite={c} key={`${c.url}-${i}`} />
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
}

export default FullResponseModal;
